/**
 * Configurações e utilitários de ambiente
 */

export enum Environment {
  PRODUCTION = 'production',
  STAGING = 'staging',
  DEVELOPMENT = 'development',
}

/**
 * Detecta o ambiente atual baseado no hostname e NODE_ENV
 */
export const getCurrentEnvironment = (): Environment => {
  const hostname = window.location.hostname;
  
  if (process.env.NODE_ENV === 'development') {
    return Environment.DEVELOPMENT;
  }
  
  if (hostname.includes('staging')) {
    return Environment.STAGING;
  }
  
  return Environment.PRODUCTION;
};

/**
 * Verifica se está rodando em ambiente de produção
 */
export const isProduction = (): boolean => {
  return getCurrentEnvironment() === Environment.PRODUCTION;
};

/**
 * Verifica se está rodando em ambiente de desenvolvimento
 */
export const isDevelopment = (): boolean => {
  return getCurrentEnvironment() === Environment.DEVELOPMENT;
};

/**
 * Verifica se está rodando em ambiente de staging
 */
export const isStaging = (): boolean => {
  return getCurrentEnvironment() === Environment.STAGING;
};

/**
 * Configuração de features baseada em ambiente
 */
export const FeatureFlags = {
  /**
   * Define se deve trackear analytics (views, clicks, etc)
   */
  enableAnalytics: isProduction(),
  
  /**
   * Define se deve exibir logs de debug
   */
  enableDebugLogs: !isProduction(),
};

